import AdvancedImage from '@components/image/WithFallback'
import cloudflarePhoto from '@utils/links/cloudflarePhoto'
import fullPhoto from '@utils/links/fullPhoto'
import makeYoutubeThumbnailResolver from '@utils/video/makeYoutubeThumbnailResolver'
import resolveCloudflareSrcSet from './functions/resolveCloudflareSrcSet'

import styles from './OfferImage.module.css'

function OfferImage ({
    alt,
    offer,
    preferredOrder = 0,
    preferredVariant = 'list',
    preferredHeight = 681,
    preferredWidth = 1024,
    priority = false,
    src,
    variantSrcSet,
    variantSrcSetSizes,
}) {
    const { tracking, video_link } = offer || {}
    const { cloudflare, pid } = tracking || {}
    const { mainPhoto, photos = [] } = cloudflare || {}

    const hasCloudflarePhotos = mainPhoto || photos.length
    const cloudflareImageId = hasCloudflarePhotos && photos[preferredOrder] || mainPhoto
    const customFallbackResolver = video_link && makeYoutubeThumbnailResolver(video_link)

    const loading = priority ? 'eager' : 'lazy'

    return hasCloudflarePhotos
        ? <AdvancedImage
            alt={alt}
            className={styles['cf-image']}
            customFallbackResolver={customFallbackResolver}
            loading={loading}
            priority={priority}
            sizes={variantSrcSetSizes}
            src={src || cloudflarePhoto(cloudflareImageId, preferredVariant)}
            srcSet={variantSrcSet ? resolveCloudflareSrcSet(variantSrcSet, cloudflareImageId) : undefined}
            useNextImage={false}
        />

        : <AdvancedImage
            alt={alt}
            loading={loading}
            customFallbackResolver={customFallbackResolver}
            height={preferredHeight}
            priority={priority}
            src={src || fullPhoto(pid, preferredOrder)}
            useNextImage={true}
            width={preferredWidth}
          />
}

export {
    OfferImage,
}